module.exports = __webpack_public_path__ + "img/mtl-trajet-c.be49b14e.png";